import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Shuffle } from "lucide-react";

export default function MergeDialog({
  open, onOpenChange, selectedIds, tournees,
  primaryId, setPrimaryId, date, setDate,
  submitting, onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="merge-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Shuffle className="w-5 h-5 text-indigo-600" />
            Fusionner {selectedIds.size} tournées
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <p className="text-sm text-slate-600">
            Choisis la tournée <b>principale</b>. Les autres seront absorbées dedans (leurs arrêts, enveloppes et frais seront transférés), puis envoyées en Corbeille (restaurables 15 jours).
          </p>
          <div className="space-y-2">
            <Label>Tournée principale (gardera son nom)</Label>
            <Select value={primaryId} onValueChange={setPrimaryId}>
              <SelectTrigger data-testid="merge-primary-select"><SelectValue placeholder="Choisir…" /></SelectTrigger>
              <SelectContent>
                {Array.from(selectedIds).map(id => {
                  const t = tournees.find(x => x.id === id);
                  return t ? <SelectItem key={id} value={id}>{t.nom} ({t.date})</SelectItem> : null;
                })}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Date unifiée</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="merge-date-input" />
          </div>
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 text-xs">
            <p className="font-semibold text-indigo-700 mb-1">Ce qui va se passer :</p>
            <ul className="text-indigo-700 space-y-0.5 list-disc list-inside">
              <li>Tous les arrêts rassemblés dans la tournée principale</li>
              <li>Trajet re-optimisé automatiquement (ordre le + court)</li>
              <li>Enveloppes montants additionnés</li>
              <li>Frais de tournée fusionnés</li>
              <li>Les {selectedIds.size - 1} autre(s) tournée(s) → Corbeille</li>
            </ul>
          </div>
          <p className="text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded p-2">
            ⚠️ Les SMS déjà envoyés aux clients ne seront pas rappelés. Si l'heure de passage change, renvoie un SMS manuellement.
          </p>
          {Array.from(selectedIds).some(id => {
            const t = tournees.find(x => x.id === id);
            return t && t.statut === "terminee";
          }) && (
            <p className="text-xs text-red-700 bg-red-50 border border-red-200 rounded p-2 font-medium" data-testid="merge-terminee-warning">
              ⛔ Tu vas fusionner des tournées déjà <b>terminées</b>. Les statistiques des journées concernées (distance, coût, enveloppes) vont être recalculées et rapportées sur la tournée principale.
            </p>
          )}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button onClick={onConfirm} className="bg-indigo-600 hover:bg-indigo-700" disabled={submitting || !primaryId} data-testid="merge-confirm-btn">
              {submitting ? "Fusion…" : <><Shuffle className="w-4 h-4 mr-2" />Fusionner</>}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
